<div class="w-full h-full aligner">
  <div class="blend-filter-dot" *ngIf="params.value !== agGridCssClassEnum.Normal" [ngClass]="params.value"></div>
</div>
